import StepDrawer from './StepDrawer';
import Selector from './Selector';
import { helpers } from '../services/helpers';

function PainSelectorDrawer({
    attribute,
    setAttribute,
    currentStep,
    totalSteps,
    onCancel,
    onContinue,
    onBack,
    isEdit
}) {

    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            onCancel={onCancel}
            onContinue={onContinue}
            onBack={onBack}
            title={isEdit ? "Edit Pain Diary Entry" : "New Pain Diary Entry"}
        >
            <Selector
                score={attribute.value}
                setScore={setAttribute}
                label={`${attribute.name} Pain Level`}
                getColorForScore={helpers.getPainColorForScore}
                getIconForScore={helpers.getPainIconForScore}
                getDescriptionForScore={helpers.getPainDescriptionForScore}
            />
        </StepDrawer>
    );
}

export default PainSelectorDrawer;